import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  /* background: var(--document-background); */
  padding: 4px;
  margin-top: 10px;

  position: absolute;
  bottom: 43px !important;
  left: 40px;
  right: unset !important;
  display: flex;
  align-items: center;
  font-weight: 500;
  border: 1px solid var(--grey-2);
  border-radius: 10px;
  padding: 8px 16px 6px 12px;
  p {
    color: var(--grey-0);
    margin-left: 12px;
    margin-bottom: 1px;
  }

  svg.thumb {
    width: 24px;
    height: 24px;
    padding: 2px;

    path {
      fill: var(--grey-0);
    }
  }
`;
